import {useEffect, useState} from 'react';
import {CollapseBlock, MainTitle, Spinner} from '../../../../common/index.jsx';
import {useTranslation} from 'react-i18next';
import {useGetRoomsForReservationQuery} from '../../../../../redux/services/rooms.jsx';
import {useGetReservationsForOverviewQuery } from '../../../../../redux/services/reservations.jsx';
import ReservationsOverviewForm from '../../../../common/RoomReservations/ReservationsOverviewPage/ReservationsOverviewForm.jsx';
import ReservationsOverviewTable from '../../../../common/RoomReservations/ReservationsOverviewPage/ReservationsOverviewTable.jsx';
import dayjs from 'dayjs';

const ReservationsOverviewPage = () => {
  const {t} = useTranslation();

  const pageTitle = t('Prehľad rezervácií');

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const [selectedDate, setSelectedDate] = useState(dayjs().startOf('month'));

  const monthArg = { month: selectedDate.format('YYYY-MM') };

  const {data: reservations, isLoading: isLoadingReservations} = useGetReservationsForOverviewQuery(
    monthArg,
    {
      refetchOnMountOrArgChange: true,
      refetchOnFocus: false,
      refetchOnReconnect: false,
    }
  );
  const { data: rooms, isLoading: isLoadingRooms } = useGetRoomsForReservationQuery(undefined, {
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  });

  const [roomsFilter, setRoomsFilter] = useState([]);

  if (!rooms || !reservations || isLoadingReservations || isLoadingRooms) {
    return <Spinner/>;
  }
  return (
    <>
      <div style={{margin: '10px'}}>
        <MainTitle title={pageTitle}></MainTitle>
        <CollapseBlock title={t('Filtre rezervácií')} collapsible={true}>
          <div className="month-pick-form">
            <ReservationsOverviewForm
              onFinish={(m) => {
                setSelectedDate(m);
              }}
              setShowRooms={setRoomsFilter}
              hasDepartmentRooms={rooms.some((room) => room.department_room === 'Yes')}
            />
          </div>
        </CollapseBlock>
        <CollapseBlock title={t('Tabuľka rezervácií')} collapsible={false}>
          <ReservationsOverviewTable
            reservations={reservations}
            rooms={rooms}
            selectedDate={selectedDate}
            showOnlyRooms={roomsFilter}
            isCms={false}
          />
        </CollapseBlock>
        <CollapseBlock collapsible={true} title={t('Legenda')}>
          <div style={{paddingLeft: '15px', backgroundColor: '#ffb81c', display: 'inline'}}></div>
          &nbsp;{t('Vaša schválená rezervácia')}
          &nbsp;&nbsp;
          <div style={{paddingLeft: '15px', backgroundColor: '#f5e0b5', display: 'inline'}}></div>
          &nbsp;{t('Vaša rezervácia, čakajúca na schválenie')}
          &nbsp;&nbsp;
          <div style={{paddingLeft: '15px', backgroundColor: '#6B839F', display: 'inline'}}></div>
          &nbsp;{t('Cudzia schválená rezervácia')}
          &nbsp;&nbsp;
          <div style={{paddingLeft: '15px', backgroundColor: '#C2D6F1', display: 'inline'}}></div>
          &nbsp;{t('Cudzia rezervácia, čakajúca na schválenie')}
          &nbsp;&nbsp;
          <div style={{paddingLeft: '15px', backgroundColor: 'darkgrey', display: 'inline'}}></div>
          &nbsp;{t('rezervácia v minulosti')}
          {rooms.some((room) => room.department_room === 'Yes') && (
            <p>
              {t('Tmavšie pozadie v záhlaví tabuľky = katedrová miestnosť (iným katedrám sa nezobrazuje, povolené sú len rezervácie z katedry)')}
            </p>
          )}
        </CollapseBlock>
      </div>
    </>
  );
};

export default ReservationsOverviewPage;
